import { LegalRepresentativeDocType } from 'bff/src/domain/model/compliance.model';
import { useState } from 'react';

export type DropzoneDocumentType = {
  id?: string;
  fileName: string | undefined;
  loading: boolean;
  error: string | undefined;
};

export const initialDocument: DropzoneDocumentType = {
  fileName: undefined,
  loading: false,
  error: undefined,
};

export const useDocuments = (): [
  typeof documents,
  typeof setDocuments,
  typeof validate,
] => {
  const [contratoSocialDocData, setContratoSocialDocData] = useState<
    DropzoneDocumentType[]
  >([]);

  const [legalRepresetantDocType, setLegalRepresetantDocType] = useState<{
    value: LegalRepresentativeDocType | '';
    label: string;
    error: string;
  }>({ value: '', label: '', error: '' });

  const [legalRepresetantDocFrontData, setLegalRepresetantDocFrontData] =
    useState<DropzoneDocumentType>(initialDocument);

  const [legalRepresetantDocBackData, setLegalRepresetantDocBackData] =
    useState<DropzoneDocumentType>(initialDocument);

  const [comprovanteEnderecoDocData, setComprovanteEnderecoDocData] =
    useState<DropzoneDocumentType>(initialDocument);

  const [powerOfAttorneyDocData, setPowerOfAttorneyDocData] =
    useState<DropzoneDocumentType>(initialDocument);

  const [rentalAgreementDocData, setRentalAgreementDocData] =
    useState<DropzoneDocumentType>(initialDocument);

  const [isShareholder, setIsShareholder] = useState<boolean>(false);
  const [isRented, setIsRented] = useState<boolean>(false);

  const validateContratoSocialDocData = () => {
    return (
      contratoSocialDocData.length > 0 &&
      contratoSocialDocData.every(
        (doc) => !!doc.fileName && !doc.loading && !doc.error,
      )
    );
  };

  const validateLegalRepresetantDocType = () => {
    if (!legalRepresetantDocType?.value) {
      setLegalRepresetantDocType((prevState) => ({
        ...prevState,
        error: 'Campo é obrigatório!',
      }));
      return false;
    }
    setLegalRepresetantDocType((prevState) => ({ ...prevState, error: '' }));
    return true;
  };

  const validateLegalRepresetantDocFrontData = () =>
    !!legalRepresetantDocFrontData.fileName;

  const validateLegalRepresetantDocBackData = () =>
    legalRepresetantDocType.value === 'PASSPORT' ||
    !!legalRepresetantDocBackData.fileName;

  const documents = {
    contratoSocialDocData,
    legalRepresetantDocType,
    legalRepresetantDocFrontData,
    legalRepresetantDocBackData,
    comprovanteEnderecoDocData,
    powerOfAttorneyDocData,
    rentalAgreementDocData,
    isShareholder,
    isRented,
  };

  const setDocuments = {
    setContratoSocialDocData,
    setLegalRepresetantDocType,
    setLegalRepresetantDocFrontData,
    setLegalRepresetantDocBackData,
    setComprovanteEnderecoDocData,
    setPowerOfAttorneyDocData,
    setRentalAgreementDocData,
    setIsShareholder,
    setIsRented,
  };

  const validate = () => {
    const isContratoSocialDocValid = validateContratoSocialDocData();
    const isLegalRepresetantDocTypeValid = validateLegalRepresetantDocType();
    const isLegalRepresetantFrontValid = validateLegalRepresetantDocFrontData();
    const isLegalRepresetantBackValid = validateLegalRepresetantDocBackData();

    return (
      isContratoSocialDocValid &&
      isLegalRepresetantDocTypeValid &&
      isLegalRepresetantFrontValid &&
      isLegalRepresetantBackValid
    );
  };

  return [documents, setDocuments, validate];
};
